import { getToken } from '@/services/axios'
const VUE_APP_MOBILE_APP_DOMAIN = process.env.VUE_APP_MOBILE_APP_DOMAIN

export const isArrayEmpty = (arr: any[]): boolean => {
    return !arr || arr.length === 0 || !Array.isArray(arr)
}

export const isStrEmpty = (str: string): boolean => {
    return !str || str.length === 0 || str === 'undefined'
}

export const isObjEmpty = (obj: any): boolean => {
    return !obj || Object.keys(obj).length === 0
}

export const getParamQueryTheme = (key: string): string => {
    const search = window.location.search
    const params = new URLSearchParams(search)
    const value = params.get(key) || ''
    return value
}

export const renderNameGame = (index: number) => {
    const dictionary = {
        1: 'King [White man]',
        2: 'Monkey',
        3: 'Sea Water',
        4: 'Dead man; Turkey; Small Fortune; Bed',
        5: 'Tiger; Fight; Strong Man',
        6: 'Ox Blood; Gentleman; Milk',
        7: 'Lion; Thief; Big stick; Chickens',
        8: 'Pig; Drunken man; Loafer; Fat man; Chinese king',
        9: 'Moon; Baby; Hole; Owl; Devil; Pumpkin; Anything round',
        10: 'Eggs; Train; Boat; Grave; Anything Oval',
        11: 'Carriage; Wood; Tree; Furniture; Bicycle; Flowers',
        12: 'Dead woman; Ducks; Small fire; Chinese Queen',
        13: 'Big fish; Ghosts; Spirits',
        14: 'Old woman; Fox; Detective; Nurse; Native woman',
        15: 'Bad woman; Prostitute; Canary; White horse; Small knife',
        16: 'Small house; Coffin; Pigeon; Young woman; Paper money; Letter',
        17: 'Diamond woman; Queen; Pearls, Diamond; Stars; White woman',
        18: 'Silver money; Servant girl; Right eye; Butterfly; Hook; Rain',
        19: 'Little girl; Smoke; Bread; Big bird; Left hand',
        20: 'Cat; Sky; Handkerchief; Body; Music; Minister; Naked woman',
        21: 'Old man; Stranger; Fisherman; Elephant; Knife; Nose; Teeth',
        22: 'Rats; Motor car; Big ship; Left foot; Shoes',
        23: 'Horse; Doctor; Head; Hair; Crown',
        24: 'Mouth; Wild cat; Vixen; Lioness; Hole; Purse',
        25: 'Big house; Church; Boxer; Hospital',
        26: 'Bees; Crown; Bad man; Bush; General; Funeral; Madman',
        27: 'Dog; Policeman; Newborn baby; Medicine; Sad news',
        28: 'Sardines; Small fish; Thief; Right foot; Surprise; Small child',
        29: 'Small water; Coffin; Rain; Tears; Big knife; Right hand',
        30: 'Fowl; Graveyard; Sun; Throat; Indian; Forest',
        31: 'Big fire; Bishop; Big spirit; Feathers; Fight; Woman',
        32: 'Gold money; Dirty woman; Snake',
        33: 'Little boy; Spider',
        34: 'Meat; Human dung; Anything dirty; Cripple; Tramp',
        35: 'Clothes; Sheep; Big hole; Big grave',
        36: 'Shrimp; Stick; Admiral; Cigars; Gum',
    }

    return dictionary[index]
}

export const increaseStakePrice = (index: number) => {
    let arr: any = []
    for (let i = index; i <= 100; i++) {
        arr.push(i)
    }

    return arr
}

export const formatPrice = (number: number, decimal = 2) => {
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal,
    })
    return formatter.format(number)
}

export const formatDateUTC = (date: string | Date, timeZone = 2) => {
    const dateTimeString = date
    const dateTime = new Date(dateTimeString)

    // Chuyển múi giờ thành UTC+2
    dateTime.setHours(dateTime.getHours() + timeZone)

    const options: any = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'UTC',
    }

    const formattedDateTime = dateTime.toLocaleString('en-US', options)
    const [datePart, timePart] = formattedDateTime.split(', ')
    const [hour, minutes, seconds] = timePart.split(':')
    const [month, day, year] = datePart.split('/')

    const startOfWeek = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate() - dateTime.getDay() + 1)
    const weekDates: any = []

    for (let i = 0; i < 7; i++) {
        const date = new Date(startOfWeek.getFullYear(), startOfWeek.getMonth(), startOfWeek.getDate() + i)
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear().toString()}`
        weekDates.push(formattedDate)
    }

    const result = {
        hour,
        minutes,
        seconds,
        day,
        month,
        year,
        weekDates,
    }

    return result
}
